import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { urlAnsw } from 'src/app/common';
import { Observable, throwError } from 'rxjs';
import { Answer } from 'src/app/models/survey/answer';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AnswerService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get(`${urlAnsw}/get-all`);
  }

  getOne(id: number) {
    return this.http.get(`${urlAnsw}/get-one/${id}`);
  }

  getAllUuid(uuid: string) {
    return this.http.get(`${urlAnsw}/get-all-uuid/${uuid}`).pipe(
      catchError(this.handleError)
    );
  }

  create(data: Answer): Observable<Answer> {
    return this.http.post(`${urlAnsw}/create`, data);
  }

  update(id: number, data: Answer): Observable<Answer> {
    return this.http.put(`${urlAnsw}/update/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${urlAnsw}/delete/${id}`);
  }

  checkIfExists(idquestion: number, idsurveyed: number, idoptions: number | null, uuid: string, idrow: number | null, idcolumn: number | null): Observable<{ exists: boolean, id?: number }> {
    return this.http.post<{ exists: boolean, id?: number }>(`${urlAnsw}/check-if-exists`, { idquestion, idsurveyed, idoptions, uuid, idrow, idcolumn });
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Backend error
      errorMessage = `Server Error: ${error.status}, Message: ${error.error.message}`;
    }
    return throwError(errorMessage);
  }
}
